import { ref, BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { number_format, num_word, decodeBase64, fastBuy, formatFileSize, normalizeStockStatusCode, stockPositiveTotal, stockStoreAmount, stockStoreText, markClass } from 'vpl.tas';
import { VplRouter, ymLead, ymBasketEvents, ymProductDetail, MessengerLinks, NewsletterCheckbox } from 'vpl.tas';

export const CatalogElement = {
    props: {
        structKey: [String, Number],
    },
    computed: {
        ...mapState(vplSiteStore, ['basket', 'compare', 'favorite', 'struct', 'SITE_TEMPLATE_PATH', 'RE_SITE_KEY', 'ancor']),
        item() {
            return this.struct[this.structKey].componentData.ITEM;
        },
        itemProps() {
            let arReturn = [], counter = 0;;
            for (let i in this.item.PROPS) {
                arReturn.push(this.item.PROPS[i]);
                counter++;
                if (counter >= 4) break;
            }
            return arReturn;
        }
    },
    components: {
        MessengerLinks,
        NewsletterCheckbox,
    },
    watch: {
        // SPA-переход товар → товар может переиспользовать экземпляр: detail на каждый показ
        'item.ID'() {
            ymProductDetail(this.item);
        },
    },
    mounted() {
        ymProductDetail(this.item); // e-commerce detail: просмотр карточки товара

                $(this.$el).find(".js-input-touchspin").each(function () {
            const touchSpinOptions = { min: 1 };
            $(this).show().TouchSpin(touchSpinOptions);
        });

        if (this.ancor) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#" + this.ancor).offset().top - 70
            }, 500);
        }

        if (this.item.GALLERY.length) {

            let sliderParams = {
                loop: true,
                spaceBetween: 10,
                grabCursor: true,
            };

            if (this.item.GALLERY.length > 1) {

                let prodSliderNav = new Swiper(".js-product-detail-slider-nav", {
                    loop: true,
                    spaceBetween: 9,
                    slidesPerView: 5,
                    grabCursor: true,
                    watchSlidesProgress: true,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.4,
                            spaceBetween: 10
                        },
                        576: {
                            slidesPerView: 2.4,
                            spaceBetween: 10
                        },
                        768: {
                            slidesPerView: 5,
                            spaceBetween: 9
                        },
                        1200: {
                            slidesPerView: 5,
                            spaceBetween: 9
                        }
                    }
                });

                sliderParams['thumbs'] = {
                    swiper: prodSliderNav
                };
                sliderParams['pagination'] = {
                    el: ".js-product-detail-slider-pag",
                    type: "bullets",
                    clickable: true
                };
            }

            let prodSliderMain = new Swiper(".js-product-detail-slider-main", sliderParams);

        }

        let SwiperMoreBuy = new Swiper('.js-product-detail-more', {
            loop: true,
            lazyPreloadPrevNext: 2,
            grabCursor: true,
            slidesPerView: 3,
            spaceBetween: 10,
            // autoplay: {
            //   delay: 3000,
            // },
            navigation: {
                nextEl: ".js-product-detail-more-next",
                prevEl: ".js-product-detail-more-prev"
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 8
                },
                576: {
                    slidesPerView: 2.4,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 10
                }
            }
        });

        $(this.$el).find('[data-fancybox]').fancybox({
            loop: true,
        });

        if ($('.js-detail-content-text').length && $('.js-detail-content-text').outerHeight() >= 95) {
            $('.js-detail-content-text').addClass('is-bigger');
            $('.js-detail-content-btn').addClass('is-bigger');
        }

        if ($('.js-detail-content-text').length && $('.js-detail-content-text').outerHeight() >= 95) {
            $('.js-detail-content-text').addClass('is-bigger');
            $('.js-detail-content-btn').addClass('is-bigger');
        }

        $('.js-prod-det-chars-wp').each(function () {
            let itemsChars = $(this).find('.js-detail-chars-item-n').length;
            let itemsCharsWp = $(this).find('.js-prod-det-chars-wp');
            let itemsCharsBtn = $(this).find('.js-detail-chars-btn-n');

            if (itemsChars > 4) {
                itemsCharsBtn.show();
            } else {
                itemsCharsBtn.hide();
            }
        });

        $('.js-detail-chars-btn-n').click(function (e) {
            e.preventDefault();
            if (!$(this).hasClass('is-show')) {
                $(this).addClass('is-show');
                $(this).text('Свернуть');
                $(this).closest('.js-prod-det-chars-wp').addClass('is-show');
            } else {
                $(this).removeClass('is-show');
                $(this).text('Показать ещё');
                $(this).closest('.js-prod-det-chars-wp').removeClass('is-show');
            }
        });

        function hideBtnEquipDesctop(amount, item, btn) {
            if (item.length > amount) {
                btn.show();
            } else {
                btn.hide();
            }
        };

        hideBtnEquipDesctop(4, $('.js-questions-item'), $('.js-questions-showmore'));

        function clickBtns(btn, list) {
            btn.click(function (e) {
                e.preventDefault();

                if (!$(this).hasClass('is-show')) {
                    $(this).addClass('is-show');
                    $(this).text('Свернуть');
                    list.addClass('is-show');
                } else {
                    $(this).removeClass('is-show');
                    $(this).text('Показать ещё');
                    list.removeClass('is-show');
                }
            });
        };

        clickBtns($('.js-questions-showmore'), $('.js-questions-wp'));

    },
    data() {
        return {
            inCart: false,
            shareObj: false
        }
    },
    methods: {
        num_word: num_word,
        number_format: number_format,
        decodeBase64: decodeBase64,
        fastBuy: fastBuy,
        formatFileSize: formatFileSize,
        normalizeStockStatusCode: normalizeStockStatusCode,
        stockPositiveTotal: stockPositiveTotal,
        stockStoreAmount: stockStoreAmount,
        stockStoreText: stockStoreText,
        markClass: markClass,
        sendFavorite(id) {
            $.ajax({
                url: '/ajax/favorite.php',
                method: 'POST',
                data: { id: id },
                success: function (response) {
                    try {
                        const favoriteData = JSON.parse(response);
                        const store = vplSiteStore();
                        store.favorite = favoriteData;
                    } catch (err) { }
                }
            });
        },
        sendCompare(id) {
            $.ajax({
                url: '/ajax/compare.php',
                method: 'POST',
                data: { id: id },
                success: function (response) {
                    try {
                        const compareData = JSON.parse(response);
                        const store = vplSiteStore();
                        store.compare = compareData;
                    } catch (err) { }
                }
            });
        },
        addToBasket(id, event) {
            if (this.inCart && this.basket.ITEMS[this.item.ID] !== undefined) {
                //VplRouter('/cart/');
            } else {

                let count = ($(event.target).closest('.js-basket-block').find(".js-input-touchspin").length ? $(event.target).closest('.js-basket-block').find(".js-input-touchspin").val() : 1);

                event.preventDefault();
                $.ajax({
                    url: '/ajax/basket.php',
                    method: 'POST',
                    data: { action: 'add', id: id, 'count': count },
                    success: (response) => {
                        try {
                            const basketData = JSON.parse(response);
                            ymBasketEvents(basketData);
                            const store = vplSiteStore();
                            store.basket = basketData;
                            this.inCart = true;
                        } catch (err) { }
                    }
                });
            }
        },
        share(e) {
            /*
            if(this.shareObj == false){
              this.shareObj = Ya.share2($(e.target).find('.ya-share2')[0], {
                theme: {
                  services: 'vkontakte,odnoklassniki,telegram,twitter,whatsapp,pinterest',
                  size: 'm',
                  colorScheme: "whiteblack",
                  popupPosition: 'inner',
                  useLinks: true,
                  direction: 'horizontal'
                },
                content: {
                    url: window.location.origin + this.item.DETAIL_PAGE_URL,
                    title: this.item.NAME,
                    description: this.item.PREVIEW_TEXT,
                    image: window.location.origin + this.item.PREVIEW_IMAGE
                }
              });
            }
            */
            let link = $(e.target);
            if (!link.hasClass('is-active')) {
                link.addClass('is-active');
                link.find('.js-share-inner').addClass('is-open');
            } else {
                link.removeClass('is-active');
                link.find('.js-share-inner').removeClass('is-open');
            }

        },
        shareClick(e, type) {
            e.stopPropagation();

            let pageUrl = window.location.origin + window.location.pathname;
            const pageTitle = encodeURIComponent(document.title);

            switch (type) {
                case 'wa':
                    window.open(`https://wa.me/?text=${pageTitle}%20${pageUrl}`, '_blank').focus();
                    break;
                case 'tg':
                    window.open(`https://t.me/share/url?url=${pageUrl}&text=${pageTitle}`, '_blank').focus();
                    break;
                case 'vk':
                    window.open("https://vk.com/share.php?url=" + pageUrl, '_blank').focus();
                    break;
                case 'copy':

                    try {
                        navigator.clipboard.writeText(pageUrl);
                        alert('Ссылка скопирована в буфер обмена');
                    } catch (err) {
                        const textArea = document.createElement('textarea');
                        textArea.value = pageUrl;
                        document.body.appendChild(textArea);
                        textArea.select();

                        try {
                            document.execCommand('copy');
                            alert('Ссылка скопирована в буфер обмена');
                        } catch (err) {
                            alert('Не удалось скопировать ссылку');
                        }

                        document.body.removeChild(textArea);
                    }

                    break;
            }

            // window.open("https://vk.com/share.php?url=" + window.location.origin + window.location.pathname,"sharer","status=0,toolbar=0,width=650,height=500")

        },
        zoomIn() {
            $(this.$el).find('.js-product-detail-slider-main .swiper-slide-active a').trigger('click');
        },
        showMoreGallery() {
            $(this.$el).find('.js-product-detail-slider-main .swiper-slide a').eq(5).trigger('click');
        },
        showProps() {

            $(this.$el).find('.js-product-detail__chars-nav.is-active').removeClass('is-active');
            $(this.$el).find('.js-product-detail__chars-nav[data-chars=props]').addClass('is-active');
            $(this.$el).find('.js-product-detail__chars-content.is-active').removeClass('is-active');
            $(this.$el).find('.js-product-detail__chars-content[data-chars=props]').addClass('is-active');

            $('html, body').animate({
                scrollTop: $('#product-detail__chars').offset().top - 100
            }, 500);
        },

        toggleBlock(event, blockSelector) {
            let btn = $(event.target);

            if (!btn.hasClass('is-show')) {
                btn.addClass('is-show');
                btn.text('Свернуть');
                $(blockSelector).addClass('is-open');
            } else {
                btn.removeClass('is-show');
                btn.text('Показать ещё');
                $(blockSelector).removeClass('is-open');
                $('html').animate({
                    scrollTop: $(blockSelector).offset().top - 150
                }, 500);
            }
        },
        detailTabs(event) {
            let btn = $(event.target);
            $(this.$el).find('.js-product-detail__chars-nav.is-active').removeClass('is-active');
            $(this.$el).find('.js-product-detail__chars-content.is-active').removeClass('is-active');
            btn.addClass('is-active');
            $(this.$el).find('.js-product-detail__chars-content[data-chars="' + btn.data('chars') + '"]').addClass('is-active');
        },
        makeQuestionShow() {
            $(this.$el).find('#question').modal();
        },
        makeQuestion($event) {
            let form = $($event.target),
                data = {};

            data['name'] = form.find('[name=name]').val();
            data['email'] = form.find('[name=email]').val();
            data['description'] = form.find('[name=description]').val();
            if (form.find('[name=politic]').prop('checked')) {
                data['politic'] = true;
            }
            data['product'] = this.item.ID;
            data['productname'] = this.item.NAME;
            data['TAS_NEWSLETTER_CONSENT'] = form.find('[name=TAS_NEWSLETTER_CONSENT]').prop('checked') ? 'Y' : 'N';
            data['sessid'] = BX.bitrix_sessid();
            const productId = String(this.item.ID);

            $.ajax({
                url: '/ajax/question.php',
                method: 'POST',
                data: data,
                success: function (response) {
                    response = JSON.parse(response);
                    form.find('.is-error').removeClass('is-error');
                    if (response.STATUS == 'ERR') {
                        for (let i in response.ERRORS) {
                            form.find('[name=' + response.ERRORS[i] + ']').parent().addClass('is-error');
                        }
                    } else {
                        ymLead('product_question', response, { product_id: productId });
                        form.find('input[type=text],input[type=email],textarea').val('');
                        form.closest('.modal').modal('hide');
                        $('#success').modal();
                    }
                }
            });


        },
        revertQuestions() {
            this.item.QUESTIONS.reverse();
        },
        subscribeShow() {
            $(this.$el).find('#subscribe').modal();
        },
        subscribe($event) {
            let form = $(event.target),
                data = {};

            data['email'] = form.find('[name=email]').val();
            if (form.find('[name=politic]').prop('checked')) {
                data['politic'] = true;
            }
            data['product'] = this.item.ID;
            const productId = String(this.item.ID);

            $.ajax({
                url: '/ajax/productsubscribe.php',
                method: 'POST',
                data: data,
                success: function (response) {
                    response = JSON.parse(response);
                    form.find('.is-error').removeClass('is-error');
                    if (response.STATUS == 'ERR') {
                        for (let i in response.ERRORS) {
                            form.find('[name=' + response.ERRORS[i] + ']').parent().addClass('is-error');
                        }
                    } else {
                        ymLead('product_subscribe', response, { product_id: productId });
                        form.find('input,textarea').val('');
                        form.closest('.modal').modal('hide');
                        $('#successsubscribe').modal();
                    }
                }
            });

        }

    },



    template: `
    <script type="application/ld+json"></script>
<section class="product-detail" :data-product-id="item.ID">
    <div class="container">
        <div class="product-detail__wp">
            <div class="product-detail__leftside">
                <div class="product-detail__top">
                    <div class="product-detail__sliders">
                        <div class="product-detail__sliders-top">
                            <div v-if="this.item.MARKS && this.item.MARKS.length" class="product-card__tags">
                                <div v-for="mark in this.item.MARKS" :key="mark.CODE" class="product-card__tags-item" :class="markClass(mark.CODE)">{{ mark.NAME }}</div>
                            </div>
                            <div v-else class="product-card__tags">
                                <div v-if="this.item.PROMO" class="product-card__tags-item promo">Акция</div>
                                <div v-if="this.item.HIT" class="product-card__tags-item hit">Хит продаж</div>
                                <div v-if="this.item.SALE" class="product-card__tags-item sale">Распродажа</div>
                                <div v-if="this.item.NEW" class="product-card__tags-item new">Новинка</div>
                            </div>
                            <div class="product-card__del">
                                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                            </div>

                            <template v-if="this.item.GALLERY.length">
                              <a href="#" @click.prevent="zoomIn()" class="zoom js-detail-zoom">
                                  <svg class="icon icon-zoom"><use xlink:href="#icon-zoom"></use></svg>
                              </a>
                              <div class="swiper product-detail__sliders-main js-product-detail-slider-main">
                                  <div class="swiper-wrapper">
                                      <template v-for="galItem in this.item.GALLERY">
                                        <div v-if="galItem.TYPE == 'VIDEO'" class="swiper-slide">
                                            <a :href="galItem.SRC" class="product-detail__sliders-main-img" :class="{'no-photo': (galItem.MEDIUM == false)}" data-fancybox="prod-detail">
                                                <video :poster="(galItem.MEDIUM !== false ? galItem.MEDIUM : this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg')" id="product-detail-video" preload="metadata" playsinline="" webkit-playsinline="" loop="" muted="">
                                                    <source :src="galItem.SRC" :type="galItem.CONTENT_TYPE">
                                                </video>
                                                <span class="product-detail__sliders-nav-img-icon">
                                                    <svg class="ico ico-play-mini" width="21" height="21" aria-hidden="true"><use xlink:href="#ico-play-mini"></use></svg>
                                                </span>
                                            </a>
                                        </div>
                                        <div v-if="galItem.TYPE == 'IMAGE'" class="swiper-slide">
                                            <a :href="galItem.BIG" class="product-detail__sliders-main-img" data-fancybox="prod-detail">
                                                <img :src="galItem.MEDIUM" :alt="this.item.NAME" :title="this.item.NAME" loading="lazy">
                                            </a>
                                        </div>
                                      </template>
                                  </div>
                              </div>
                            </template>
                            <template v-else>
                              <div class="swiper product-detail__sliders-main">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <span class="product-detail__sliders-main-img no-photo">
                                            <img :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="this.item.NAME" :title="this.item.NAME" loading="lazy">
                                        </span>
                                    </div>
                                </div>
                              </div>
                            </template>
                        </div>
                        <template v-if="this.item.GALLERY.length > 1">
                          <div class="swiper-pagination js-product-detail-slider-pag"></div>
                          <div class="product-detail__sliders-bottom">
                              <div class="swiper product-detail__sliders-nav js-product-detail-slider-nav">
                                  <div class="swiper-wrapper">
                                      <template v-for="galItem in this.item.GALLERY">
                                        <div v-if="galItem.TYPE == 'IMAGE'" class="swiper-slide">
                                            <div class="product-detail__sliders-nav-img">
                                                <img :src="galItem.SMALL" :alt="this.item.NAME" :title="this.item.NAME" loading="lazy">
                                            </div>
                                        </div>

                                        <div v-if="galItem.TYPE == 'VIDEO'" class="swiper-slide">
                                            <div class="product-detail__sliders-nav-img video" :class="{'no-photo': (galItem.SMALL == false)}">
                                                <img :src="(galItem.SMALL !== false ? galItem.SMALL : this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg')" :alt="this.item.NAME" :title="this.item.NAME" loading="lazy">
                                                <span class="product-detail__sliders-nav-img-icon">
                                                    <svg class="ico ico-play-mini" width="21" height="21" aria-hidden="true"><use xlink:href="#ico-play-mini"></use></svg>
                                                </span>
                                            </div>
                                        </div>
                                      </template>
                                  </div>
                              </div>
                              <a v-if="this.item.GALLERY.length > 5" href="#" @click.prevent="showMoreGallery()" class="product-detail__sliders-more">ещё</a>
                          </div>
                        </template>
                    </div>
                    <div class="product-detail__info">
                        <h1 class="product-detail__title" v-html="this.item.NAME">
                        </h1>
                        <div v-if="this.item.ARTNUMBER" class="product-detail__art">
                            Код товара: {{this.item.ARTNUMBER}}
                        </div>
                        <a v-if="this.item.BRAND" :href="this.item.BRAND.LINK" class="product-detail__brand">
                            <div class="product-detail__brand-img">
                                <img :src="(this.item.BRAND.IMAGE !== false ? this.item.BRAND.IMAGE : this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg')" :alt="this.item.BRAND.NAME" :title="this.item.BRAND.NAME" loading="lazy">
                            </div>
                            <div class="product-detail__brand-info">
                                <div class="product-detail__brand-name">{{this.item.BRAND.NAME}}</div>
                                <div v-if="this.item.BRAND.FLAG || this.item.BRAND.COUNTRY" class="product-detail__brand-country">
                                    <img v-if="this.item.BRAND.FLAG" :src="this.item.BRAND.FLAG" alt="" title="" loading="lazy">
                                    {{this.item.BRAND.COUNTRY}}
                                </div>
                            </div>
                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                        </a>

                        <template v-if="this.item.PROPS.length">
                          <ul class="product-detail__chars">
                              <li v-for="prop in this.itemProps">
                                  <div class="product-detail__chars-name">{{prop.NAME}}</div>
                                  <div class="product-detail__chars-value" v-html="prop.VALUE"></div>
                              </li>
                          </ul>
                          <a href="#" class="product-detail__chars-btn" @click.prevent="showProps()">
                              Все характеристики
                              <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                          </a>
                        </template>

                        <div class="product-detail__actions">

                            <div class="product-detail__actions-links">
                                <a v-if="this.compare" href="#" class="product-card__info-actions-item" :class="{'is-active': Object.keys(this.compare).includes(''+this.item.ID)}" @click.prevent="sendCompare(this.item.ID)">
                                    <div class="product-card__info-actions-item-informer">
                                      <span v-if="this.compare && Object.keys(this.compare).includes(''+this.item.ID)">В сравнении</span>
                                      <span v-else>Сравнить</span>
                                    </div>
                                    <svg class="icon icon-compare"><use xlink:href="#icon-compare"></use></svg>
                                </a>
                                <a v-if="this.favorite" href="#" class="product-card__info-actions-item" :class="{'is-active': Object.keys(this.favorite).includes(''+this.item.ID)}" @click.prevent="sendFavorite(this.item.ID)">
                                    <div class="product-card__info-actions-item-informer">
                                      <span v-if="this.favorite && Object.keys(this.favorite).includes(''+this.item.ID)">В избранном</span>
                                      <span v-else>В избранное</span>
                                    </div>
                                    <svg class="icon icon-fav"><use xlink:href="#icon-fav"></use></svg>
                                </a>
                            </div>

                            <div v-if="this.item.PRICE && this.item.PRICE.PRICE" class="product-detail__actions-price">
                                <div class="product-card__price">
                                    {{ number_format(this.item.PRICE.PRICE, 0, '.', ' ') }} ₽
                                    <div class="product-card__price-old-wp">
                                      <div class="product-card__price-old" v-if="this.item.PRICE.PRICE != this.item.PRICE.BASE_PRICE">
                                        <span>{{ number_format(parseInt(this.item.PRICE.BASE_PRICE), 0, '.', ' ') }} ₽ </span>
                                        <div v-if="this.item.PRICE.PERCENT" class="product-card__price-discount">{{this.item.PRICE.PERCENT}}%</div>
                                      </div>
                                      <div v-if="this.item.NDS" class="product-card__price-old-informer">
                                          с НДС {{this.item.NDS}}%
                                          <div class="product-card__price-old-informer-dropdown-wp">
                                              <span class="product-card__price-old-informer-ico">?</span>
                                              <div class="product-card__price-old-informer-dropdown">
                                                  Цена указана с НДС
                                              </div>
                                          </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else="this.item.PRICE && this.item.PRICE.PRICE" class="product-detail__actions-price">
                              <div class="product-card__price">
                                По запросу
                              </div>
                            </div>

                            <div
  v-if="this.item.STOCK_STATUS_TEXT"
  class="product-detail__actions-tags tas-refro-status-badge"
  :data-stock-status="normalizeStockStatusCode(this.item.STOCK_STATUS_CODE)"
>
  <div class="product-card__amount-item amount" v-text="this.item.STOCK_STATUS_TEXT"></div>
  <span
    v-if="stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL) > 0"
    class="tas-refro-status-qty"
  >{{ stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL) }} шт.</span>
</div>

<div
  v-if="
    this.basket.ITEMS[this.item.ID] !== undefined
    && +this.basket.ITEMS[this.item.ID].QUANTITY > stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL)
  "
  class="product-detail__actions-tags tas-product-supply-split"
>
  <div
    v-if="stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL) > 0"
    class="product-card__amount-item amount"
  >
    {{ stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL) }} шт. — из наличия
  </div>

  <div class="product-card__amount-item delivery">
    {{
      +this.basket.ITEMS[this.item.ID].QUANTITY
      - stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL)
    }} шт. — поставка под заказ
  </div>

  <div class="product-card__amount-item delivery tas-product-supply-note">
    Срок поставки уточнит менеджер
  </div>
</div>

                            <div class="product-detail__basket js-basket-block">
                                <input
                                    v-if="this.item.STOCK_STATUS_CODE == 'in_stock' || this.item.STOCK_STATUS_CODE == 'to_order'"
                                    type="text"
                                    aria-label=""
                                    class="input-touchspin js-input-touchspin"
                                    :value="this.basket.ITEMS[this.item.ID] !== undefined ? this.basket.ITEMS[this.item.ID].QUANTITY : 1"
                                >
                                <a v-if="this.basket.ITEMS[this.item.ID] !== undefined"
                                    href="/cart/"
                                    class="btn btn--green product-detail__btn-basket basket-in"
                                    >
                                    <span class="basket-in">
                                        <svg class="ico ico-done" width="17" height="17" aria-hidden="true"><use xlink:href="#ico-done"></use></svg>
                                        В корзине
                                    </span>
                                </a>
                                <a v-else-if="!this.inCart && this.basket.ITEMS[this.item.ID] === undefined && this.item.STOCK_STATUS_CODE == 'in_stock'"
                                    href="/cart/"
                                    @click="addToBasket(this.item.ID, $event)"
                                    class="btn btn--green product-detail__btn-basket"
                                    >
                                    <span class="basket-default">Купить</span>
                                </a>
                                <a v-else-if="!this.inCart && this.basket.ITEMS[this.item.ID] === undefined && this.item.STOCK_STATUS_CODE == 'to_order'"
                                    href="/cart/"
                                    @click="addToBasket(this.item.ID, $event)"
                                    class="btn btn--green product-detail__btn-basket basket-order"
                                    >
                                    <span class="basket-order">Купить</span>
                                </a>

<a v-else-if="this.item.STOCK_STATUS_CODE == 'individual_calculation'"
    href="#"
    @click.prevent="fastBuy(this.item.ID, 'Запросить расчет')"
    class="btn btn--green product-detail__btn-basket"
    >
    <span class="basket-default">Запросить расчет</span>
</a>

<a v-else-if="this.item.STOCK_STATUS_CODE == 'discontinued'"
    href="#"
    @click.prevent="fastBuy(this.item.ID, 'Подобрать аналог')"
    class="btn btn--green product-detail__btn-basket basket-order"
    >
    <span class="basket-order">Подобрать аналог</span>
</a>
                            </div>

                            <a href="#" v-if="false && (this.item.QUANTITY > 0 || this.item.TO_ORDER == 'Y' && this.item.DELIVERY_TIME)" class="btn btn--border buy-oneclick" @click.prevent="fastBuy(this.item.ID)">Купить в 1 клик</a>

                            <div class="product-detail__share js-share" @click="share($event)">
                                <svg class="icon icon-share"><use xlink:href="#icon-share"></use></svg>
                                Поделиться товаром
                                <div class="product-detail__share-inner js-share-inner">
                                  <a class="product-detail__share-inner-item"
                                          @click.prevent="shareClick($event, 'wa')"
                                          title="">
                                          <svg class="ico ico-wa" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-wa"></use></svg>
                                  </a>
                                  <a class="product-detail__share-inner-item"
                                          @click.prevent="shareClick($event, 'tg')"
                                          title="">
                                          <svg class="ico ico-tg" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-tg"></use></svg>
                                  </a>
                                  <a class="product-detail__share-inner-item"
                                          @click.prevent="shareClick($event, 'vk')"
                                          title="">
                                          <svg class="ico ico-vk" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-vk"></use></svg>
                                  </a>
                                  <a class="product-detail__share-inner-item"
                                          @click.prevent="shareClick($event, 'copy')"
                                          title="">
                                          <svg class="ico ico-copy" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-copy"></use></svg>
                                  </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div v-if="this.item.RELATED.length" class="product-detail__more-wp">
                    <div class="product-detail__more-title">С этим товаром покупают</div>
                    <div class="slider-buttons">
                        <div class="swiper-button-prev slider-btn js-product-detail-more-prev">
                          <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                        </div>
                        <div class="swiper product-detail__slider-more js-product-detail-more">
                          <div class="swiper-wrapper">

                            <div v-for="related in this.item.RELATED" class="swiper-slide">
                              <a :href="related.LINK" class="viewed-products__card">
                                <div class="viewed-products__card-heading">
                                  <div class="viewed-products__card-name">
                                    {{related.NAME}}
                                  </div>
                                  <div class="viewed-products__card-img" :class="{'no-photo': related.IMAGE === false}">
                                    <img v-if="related.IMAGE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="related.IMAGE" :alt="related.NAME" :title="related.NAME">
                                    <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="related.NAME" :title="related.NAME">
                                  </div>
                                </div>
                                <div class="product-card__price">
                                {{ number_format(related.PRICE.RESULT_PRICE.DISCOUNT_PRICE, 0, '.', ' ') }} ₽
                                  <div v-if="related.PRICE.RESULT_PRICE.DISCOUNT_PRICE < related.PRICE.RESULT_PRICE.BASE_PRICE" class="product-card__price-old">
                                    <span>{{ number_format(related.PRICE.RESULT_PRICE.BASE_PRICE, 0, '.', ' ') }} ₽ </span>
                                    <div v-if="related.PRICE.RESULT_PRICE.PERCENT" class="product-card__price-discount">{{related.PRICE.RESULT_PRICE.PERCENT}}%</div>
                                  </div>
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="swiper-button-next slider-btn js-product-detail-more-next">
                          <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                        </div>
                    </div>
                </div>


                <div class="product-detail__chars-block" id="product-detail__chars">
                    <div class="product-detail__chars__nav">
                        <a href="#" v-if="this.item.DETAIL_TEXT" class="product-detail__chars__nav-item js-product-detail__chars-nav is-active" @click.prevent="detailTabs($event)" data-chars="text">Описание</a>
                        <a href="#" v-if="this.item.PROPS.length" class="product-detail__chars__nav-item js-product-detail__chars-nav" @click.prevent="detailTabs($event)" :class="{'is-active': !this.item.DETAIL_TEXT}" data-chars="props">Характеристики</a>
                        <a href="#" v-if="this.item.VIDEO.length" class="product-detail__chars__nav-item js-product-detail__chars-nav" @click.prevent="detailTabs($event)" :class="{'is-active': !this.item.DETAIL_TEXT && !this.item.PROPS.length}" data-chars="video">Видеообзоры</a>
                        <a href="#" v-if="this.item.QUESTIONS.length" class="product-detail__chars__nav-item js-product-detail__chars-nav" @click.prevent="detailTabs($event)" :class="{'is-active': !this.item.DETAIL_TEXT && !this.item.PROPS.length && !this.item.VIDEO.length}" data-chars="question">Вопросы</a>
                    </div>
                    <div class="product-detail__chars-content">
                        <div v-if="this.item.DETAIL_TEXT" class="product-detail__chars-content-item js-product-detail__chars-content is-active" data-chars="text">
                            <div class="product-detail__chars-content-item-wp content js-detail-content-text" v-text="this.item.DETAIL_TEXT"></div>
                            <a href="#" class="btn-showmore js-detail-content-btn" @click.prevent="toggleBlock($event, '.js-detail-content-text')">
                                Показать ещё
                            </a>
                        </div>
                        <div v-if="this.item.PROPS.length" class="product-detail__chars-content-item js-product-detail__chars-content" :class="{'is-active': !this.item.DETAIL_TEXT}" data-chars="props">

                            <div v-for="propGroup in this.item.GROUPPED_PROPS" class="product-detail__chars-wp js-prod-det-chars-wp">
                                <div class="product-detail__chars-title">{{propGroup.NAME}}</div>
                                <ul class="product-detail__chars js-detail-chars-list">
                                    <li v-for="prop in propGroup.PROPS" class="js-detail-chars-item-n">
                                        <div class="product-detail__chars-name">{{prop.NAME}}</div>
                                        <div class="product-detail__chars-value" v-html="prop.VALUE"></div>
                                    </li>
                                </ul>
                                <a href="#" class="btn-showmore js-detail-chars-btn-n">
                                    Показать ещё
                                </a>
                            </div>
                        </div>
                        <div v-if="this.item.VIDEO.length" class="product-detail__chars-content-item js-product-detail__chars-content" :class="{'is-active': !this.item.DETAIL_TEXT && !this.item.PROPS.length}" data-chars="video">
                            <div class="product-detail__video-list js-detail-video-list">

                                <div v-for="video in this.item.VIDEO" class="video-item js-detail-video-item">
                                    <a :href="video.VIDEO.SRC" class="video-item__img" data-fancybox="video-image">
                                        <video id="product-obzor-video" :poster="video.POSTER" preload="metadata" playsinline="" webkit-playsinline="" loop="" muted="">
                                            <source :src="video.VIDEO.SRC" :type="video.VIDEO.CONTENT_TYPE">
                                        </video>
                                        <span class="video-item__img-icon">
                                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                                        </span>
                                    </a>
                                    <a :href="video.VIDEO.SRC" class="video-item__name" data-fancybox="video-name">
                                        {{video.NAME}}
                                    </a>
                                    <div class="video-item__info">
                                        <div class="video-item__info-size">
                                            {{this.formatFileSize(video.VIDEO.FILE_SIZE)}}
                                        </div>
                                        <div class="video-item__info-icon">
                                            <svg class="icon icon-download"><use xlink:href="#icon-download"></use></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a href="#" class="btn-showmore js-detail-video-btn" @click.prevent="toggleBlock($event, '.js-detail-video-list')" :class="{'is-active': this.item.VIDEO.length > 3}">
                                Показать ещё
                            </a>
                        </div>
                    </div>
                    <div v-if="this.item.QUESTIONS.length" class="product-detail__chars-content-item js-product-detail__chars-content" :class="{'is-active': !this.item.DETAIL_TEXT && !this.item.PROPS.length && !this.item.VIDEO.length}" data-chars="question">
                            <div class="product-detail__questions-wp js-questions-wp">
                              <div class="product-detail__questions-sort">
                                  <a href="#" class="product-detail__questions-sort-btn" @click.prevent="revertQuestions()">
                                      Дата
                                      <svg class="icon icon-questions-sort"><use xlink:href="#icon-questions-sort"></use></svg>
                                  </a>
                              </div>
                              <div class="product-detail__questions">

                                  <div v-for="question in this.item.QUESTIONS" class="product-detail__questions-item js-questions-item">
                                      <div class="product-detail__questions-item-leftside">
                                          <div class="product-detail__questions-item-img" :class="{'no-photo': (this.item.PREVIEW_IMAGE  == '')}">
                                              <img v-if="this.item.PREVIEW_IMAGE !== ''" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="this.item.PREVIEW_IMAGE" alt="" title="">
                                              <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" alt="" title="">
                                          </div>
                                          <div class="product-detail__questions-item-date">{{question.DATE}}</div>
                                      </div>
                                      <div class="product-detail__questions-item-rightside">
                                          <div class="product-detail__questions-item-top">
                                              <div class="product-detail__questions-item-name">
                                                  Вопрос о {{question.PRODUCT}}
                                                  <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                                              </div>
                                              <div class="product-detail__questions-item-text">
                                                  {{question.QUESTION}}
                                              </div>
                                          </div>
                                          <div v-if="question.ANSWER.length" class="product-detail__questions-item-answer" v-html="question.ANSWER">
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <a href="#" class="btn btn--border js-questions-showmore">
                                  Показать ещё
                              </a>
                          </div>
                    </div>
                </div>
            </div>
            <div class="product-detail__rightside">
                <div class="product-detail__actions">
                    <div class="product-detail__actions-links">
                      <a v-if="this.compare" href="#" class="product-card__info-actions-item" :class="{'is-active': Object.keys(this.compare).includes(''+this.item.ID)}" @click.prevent="sendCompare(this.item.ID)">
                          <div class="product-card__info-actions-item-informer">
                            <span v-if="this.compare && Object.keys(this.compare).includes(''+this.item.ID)">В сравнении</span>
                            <span v-else>Сравнить</span>
                          </div>
                          <svg class="icon icon-compare"><use xlink:href="#icon-compare"></use></svg>
                      </a>
                      <a v-if="this.favorite" href="#" class="product-card__info-actions-item" :class="{'is-active': Object.keys(this.favorite).includes(''+this.item.ID)}" @click.prevent="sendFavorite(this.item.ID)">
                          <div class="product-card__info-actions-item-informer">
                            <span v-if="this.favorite && Object.keys(this.favorite).includes(''+this.item.ID)">В избранном</span>
                            <span v-else>В избранное</span>
                          </div>
                          <svg class="icon icon-fav"><use xlink:href="#icon-fav"></use></svg>
                      </a>
                    </div>

                    <div v-if="this.item.PRICE && this.item.PRICE.PRICE" class="product-detail__actions-price">
                        <div class="product-card__price">
                            {{ number_format(this.item.PRICE.PRICE, 0, '.', ' ') }} ₽
                            <div class="product-card__price-old-wp">
                              <div class="product-card__price-old" v-if="this.item.PRICE.PRICE != this.item.PRICE.BASE_PRICE">
                                <span>{{ number_format(parseInt(this.item.PRICE.BASE_PRICE), 0, '.', ' ') }} ₽ </span>
                                <div v-if="this.item.PRICE.PERCENT" class="product-card__price-discount">{{this.item.PRICE.PERCENT}}%</div>
                              </div>
                              <div v-if="this.item.NDS" class="product-card__price-old-informer">
                                  с НДС {{this.item.NDS}}%
                                  <div class="product-card__price-old-informer-dropdown-wp">
                                      <span class="product-card__price-old-informer-ico">?</span>
                                      <div class="product-card__price-old-informer-dropdown">
                                          Цена указана с НДС
                                      </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div v-else="this.item.PRICE && this.item.PRICE.PRICE" class="product-detail__actions-price">
                      <div class="product-card__price">
                        По запросу
                      </div>
                    </div>


                    <div
  v-if="this.item.STOCK_STATUS_TEXT"
  class="product-detail__actions-tags tas-refro-status-badge"
  :data-stock-status="normalizeStockStatusCode(this.item.STOCK_STATUS_CODE)"
>
  <div class="product-card__amount-item amount" v-text="this.item.STOCK_STATUS_TEXT"></div>
  <span
    v-if="stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL) > 0"
    class="tas-refro-status-qty"
  >{{ stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL) }} шт.</span>
</div>

<div
  v-if="
    this.basket.ITEMS[this.item.ID] !== undefined
    && +this.basket.ITEMS[this.item.ID].QUANTITY > stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL)
  "
  class="product-detail__actions-tags tas-product-supply-split"
>
  <div
    v-if="stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL) > 0"
    class="product-card__amount-item amount"
  >
    {{ stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL) }} шт. — из наличия
  </div>

  <div class="product-card__amount-item delivery">
    {{
      +this.basket.ITEMS[this.item.ID].QUANTITY
      - stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL)
    }} шт. — поставка под заказ
  </div>

  <div class="product-card__amount-item delivery tas-product-supply-note">
    Срок поставки уточнит менеджер
  </div>
</div>

                    <div class="product-detail__basket js-basket-block">
                                <input
                                    v-if="this.item.STOCK_STATUS_CODE == 'in_stock' || this.item.STOCK_STATUS_CODE == 'to_order'"
                                    type="text"
                                    aria-label=""
                                    class="input-touchspin js-input-touchspin"
                                    :value="this.basket.ITEMS[this.item.ID] !== undefined ? this.basket.ITEMS[this.item.ID].QUANTITY : 1"
                                >
                                <a v-if="this.basket.ITEMS[this.item.ID] !== undefined"
                                    href="/cart/"
                                    class="btn btn--green product-detail__btn-basket basket-in"
                                    >
                                    <span class="basket-in">
                                        <svg class="ico ico-done" width="17" height="17" aria-hidden="true"><use xlink:href="#ico-done"></use></svg>
                                        В корзине
                                    </span>
                                </a>
                                <a v-else-if="!this.inCart && this.basket.ITEMS[this.item.ID] === undefined && this.item.STOCK_STATUS_CODE == 'in_stock'"
                                    href="/cart/"
                                    @click="addToBasket(this.item.ID, $event)"
                                    class="btn btn--green product-detail__btn-basket"
                                    >
                                    <span class="basket-default">Купить</span>
                                </a>
                                <a v-else-if="!this.inCart && this.basket.ITEMS[this.item.ID] === undefined && this.item.STOCK_STATUS_CODE == 'to_order'"
                                    href="/cart/"
                                    @click="addToBasket(this.item.ID, $event)"
                                    class="btn btn--green product-detail__btn-basket basket-order"
                                    >
                                    <span class="basket-order">Купить</span>
                                </a>

<a v-else-if="this.item.STOCK_STATUS_CODE == 'individual_calculation'"
    href="#"
    @click.prevent="fastBuy(this.item.ID, 'Запросить расчет')"
    class="btn btn--green product-detail__btn-basket"
    >
    <span class="basket-default">Запросить расчет</span>
</a>

<a v-else-if="this.item.STOCK_STATUS_CODE == 'discontinued'"
    href="#"
    @click.prevent="fastBuy(this.item.ID, 'Подобрать аналог')"
    class="btn btn--green product-detail__btn-basket basket-order"
    >
    <span class="basket-order">Подобрать аналог</span>
</a>
                            </div>

                            <a href="#" v-if="false && (this.item.QUANTITY > 0 || this.item.TO_ORDER == 'Y' && this.item.DELIVERY_TIME)" class="btn btn--border buy-oneclick" @click.prevent="fastBuy(this.item.ID)">Купить в 1 клик</a>

                    <div class="product-detail__share js-share" @click="share($event)">
                        <svg class="icon icon-share"><use xlink:href="#icon-share"></use></svg>
                        Поделиться товаром
                        <div class="product-detail__share-inner js-share-inner">
                            <a class="product-detail__share-inner-item"
                                          @click.prevent="shareClick($event, 'wa')"
                                          title="">
                                          <svg class="ico ico-wa" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-wa"></use></svg>
                                  </a>
                                  <a class="product-detail__share-inner-item"
                                          @click.prevent="shareClick($event, 'tg')"
                                          title="">
                                          <svg class="ico ico-tg" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-tg"></use></svg>
                                  </a>
                                  <a class="product-detail__share-inner-item"
                                          @click.prevent="shareClick($event, 'vk')"
                                          title="">
                                          <svg class="ico ico-vk" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-vk"></use></svg>
                                  </a>
                                  <a class="product-detail__share-inner-item"
                                          @click.prevent="shareClick($event, 'copy')"
                                          title="">
                                          <svg class="ico ico-copy" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-copy"></use></svg>
                                  </a>
                        </div>
                    </div>
                </div>
<div v-if="this.item.STOCK_STORES && this.item.STOCK_STORES.length" class="product-detail__block product-detail__stock tas-stock-stores">
    <div class="product-detail__block-title">Наличие на складах</div>

    <ul class="product-detail__block-list">
        <li
            v-for="store in this.item.STOCK_STORES"
            :key="store.STORE_ID"
            :data-store-id="store.STORE_ID || ''"
            :data-store-status="normalizeStockStatusCode(store.STATUS_CODE)"
        >
            <div class="product-detail__block-list-name">{{store.TITLE}}</div>
            <div class="product-detail__block-list-value">
                <span
                    v-if="stockStoreAmount(store) > 0 || normalizeStockStatusCode(store.STATUS_CODE) == 'in_stock'"
                    class="tas-store-qty-badge"
                >{{ stockStoreText(store) }}</span>
                <span v-else>{{ stockStoreText(store) }}</span>
            </div>
        </li>
    </ul>
</div>
                <MessengerLinks variant="product" />
                <div class="product-detail__block">
                  <div class="product-detail__block-title">Нужна помощь с выбором?</div>
                  <div class="product-detail__block-text">
                      Поможем с выбором, характеристиками и условиями покупки.
                  </div>
                  <a href="#" @click.prevent="makeQuestionShow()" class="btn btn--border">Задать вопрос</a>
                </div>
                <div class="product-detail__block">
                    <a href="#" data-toggle="modal" data-target="#delivery" class="product-detail__block-title">
                        Информация о доставке
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </a>
                    <ul class="product-detail__block-list product-detail__block-list--deilivery">
                        <li>
                            <div class="product-detail__block-list-name">Доставка внутри МКАД при заказе от 70000 руб. -  <b>бесплатно.</b></div>
                        </li>
                        <li>
                            <div class="product-detail__block-list-name">Доставка внутри МКАД при заказе до 70000 руб. - <b>1500 руб.</b>.</div>
                        </li>
                        <li>
                            <div class="product-detail__block-list-name">Доставка до терминала ТК в г. Москва - <b>бесплатно.</b></div>
                        </li>
                        <li>
                            <div class="product-detail__block-list-name">Доставка по России рассчитывается <b>индивидуально.</b></div>
                        </li>
                    </ul>
                </div>

                <div class="product-detail__block product-detail__block--payment">
                    <a href="#" data-toggle="modal" data-target="#payment" class="product-detail__block-title">
                        Оплата
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </a>
                    <ul class="product-detail__block-list">
                        <li>
                            <div class="product-detail__block-list-name">
                                <svg class="ico ico-payment2" width="18" height="14" aria-hidden="true"><use xlink:href="#ico-payment2"></use></svg>
                                Оплата по Счёту-договору для юридических и физических лиц
                            </div>
                        </li>
                        <li>
                            <div class="product-detail__block-list-name">
                                <svg class="ico ico-payment4" width="20" height="20" aria-hidden="true"><use xlink:href="#ico-payment4"></use></svg>
                                Оплата по СБП (Системе быстрых платежей) для физических лиц. Стоимость одного заказа не может превышать 1 000 000 руб.
                            </div>
                        </li>
                        <li>
                            <div class="product-detail__block-list-name">
                                <svg class="ico ico-payment3" width="20" height="15" aria-hidden="true"><use xlink:href="#ico-payment3"></use></svg>
                                Оплата наличными в офисе компании для физических лиц
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="product-detail__block">
                    <a href="/garantiya/" class="product-detail__block-title">
                        Гарантия
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </a>
                    <ul class="product-detail__block-list">
                        <li>
                            <div class="product-detail__block-list-name">Гарантийный ремонт:</div>
                            <div class="product-detail__block-list-value">Бесплатно</div>
                        </li>
                    </ul>
                </div>


                <div v-if="this.item.FILES.length" class="product-detail__downloads">

                    <a v-for="file in this.item.FILES" :href="file.SRC" target="_blank" class="product-detail__downloads-item">
                        <div class="product-detail__downloads-item-img">
                            <svg class="ico ico-pdf" width="18" height="18" aria-hidden="true"><use xlink:href="#ico-pdf"></use></svg>
                            <svg class="ico ico-pdf-h hover" width="18" height="18" aria-hidden="true"><use xlink:href="#ico-pdf-h"></use></svg>
                        </div>
                        <div class="product-detail__downloads-item-center">
                            {{file.ORIGINAL_NAME}}
                            <span>{{this.formatFileSize(file.FILE_SIZE)}}</span>
                        </div>
                        <div class="product-detail__downloads-item-icon">
                            <svg class="icon icon-download"><use xlink:href="#icon-download"></use></svg>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>



    <div class="modal fade modal-medium hide show" id="question" tabindex="-1" style="display: none;" aria-modal="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title">Задать вопрос</h2>
                    <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">
                            <svg class="icon icon-close">
                            <use xlink:href="#icon-close"></use>
                            </svg>
                        </span>
                    </button>
                </div>
                <div class="modal-body">
                    <form action="" @submit.prevent="makeQuestion($event)">
                        <div class="modal__prod">
                            <div class="modal__prod-img" :class="{'no-photo': (this.item.PREVIEW_IMAGE  == '')}" >
                                <img :src="(this.item.PREVIEW_IMAGE  !== '' ? this.item.PREVIEW_IMAGE  : this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg')" alt="" title="" loading="lazy">
                            </div>
                            <div class="modal__prod-text" v-html="this.item.NAME">
                            </div>
                        </div>
                        <div class="field js-material-input is-required" :class="{active: this.item.USER_NAME != '' }">
                            <input class="field__input" name="name" id="q-name" autocomplete="off" type="text" :value="this.item.USER_NAME">
                            <label class="field__label" for="q-name">Имя</label>
                            <span class="field__error-text">Заполнено не корректно.</span>
                        </div>
                        <div class="field js-material-input is-required" :class="{active: this.item.USER_EMAIL != '' }">
                            <input class="field__input" name="email" id="q-mail" autocomplete="off" type="text" :value="this.item.USER_EMAIL">
                            <label class="field__label" for="q-mail">Электронная почта</label>
                            <span class="field__error-text">Заполнено не корректно.</span>
                        </div>
                        <div class="field js-material-input is-required">
                            <textarea class="field__input field__input--textarea" rows="3" name="description" id="q-text"
                            placeholder="Ваше сообщение" autocomplete="off"></textarea>
                            <span class="field__error-text">Заполнено некорректно.</span>
                        </div>
                        <div class="form__submit">

                            <div class="checkbox">
                                <input type="checkbox" name="politic" class="checkbox__input js-politic js-politic-auto" id="politic-order" checked="">
                                <label for="politic-order" class="checkbox__label">
                                    Я ознакомился(лась) с <a href="/politika-konfidentsialnosti/" target="_blank">политикой конфиденциальности</a>
                                    и даю <a href="/soglasie-na-obrabotku-personalnyh-dannyh/" target="_blank">согласие на обработку моих персональных данных</a>
                                </label>
                            </div>
                            <NewsletterCheckbox />
                            <div class="form__submit-container">
                                <button type="submit" class="btn btn--green">
                                    Отправить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade modal-medium hide show" id="subscribe" tabindex="-1" style="display: none;" aria-modal="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title">Подписаться</h2>
                    <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">
                            <svg class="icon icon-close">
                                <use xlink:href="#icon-close"></use>
                            </svg>
                        </span>
                    </button>
                </div>
                <div class="modal-body">
                    <form action="" @submit.prevent="subscribe($event)">
                        <div class="modal__prod">
                            <div class="modal__prod-img" :class="{'no-photo': (this.item.PREVIEW_IMAGE  == '')}">
                                <img :src="(this.item.PREVIEW_IMAGE  !== '' ? this.item.PREVIEW_IMAGE  : this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg')" alt="" title="" loading="lazy">
                            </div>
                            <div class="modal__prod-text" v-html="this.item.NAME">
                            </div>
                        </div>
                        <div class="field js-material-input is-required" :class="{active: this.item.USER_EMAIL != '' }">
                            <input class="field__input" name="email" id="order-mail" autocomplete="off" type="text" :value="this.item.USER_EMAIL">
                            <label class="field__label" for="order-mail">Электронная почта</label>
                            <span class="field__error-text">Заполнено не корректно.</span>
                        </div>
                        <div class="form__submit">
                            <div class="checkbox">
                                <input type="checkbox" name="politic" class="checkbox__input js-politic js-politic-auto" id="politic-order" checked="">
                                <label for="politic-order" class="checkbox__label">
                                    Я ознакомился(лась) с <a href="/politika-konfidentsialnosti/" target="_blank">политикой
                                    конфиденциальности</a> и даю <a href="/soglasie-na-obrabotku-personalnyh-dannyh/" target="_blank">согласие на обработку моих персональных
                                    данных</a>
                                </label>
                            </div>
                            <div class="form__submit-container">
                                <button type="submit" class="btn btn--green">
                                    Отправить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade modal-success hide" id="successsubscribe"  tabindex="-1" style="display: none;" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">
                            <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                        </span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="modal-title">
                        Подписка оформлена
                        <br>
                        Мы уведомим Вас, когда товар станет доступен
                    </div>
                    <a href="#" data-dismiss="modal" aria-label="Close" class="btn btn--green">
                        Закрыть
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>
    `
}